import React, { FC } from 'react';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { InjectedFieldProps, PublicFieldProps } from 'react-admin';
import { JobPhaseReceivableSheetInterface } from '@vatos-pas/common';

import { PermissionsProvider } from 'providers/permissionsProvider';
import { CAN_EDIT_RECEIVABLE } from 'providers/permissions';

import { useInvoiceDraft } from '../hooks/useInvoiceRow';

type InvoiceNumberFieldProps = PublicFieldProps &
  InjectedFieldProps<JobPhaseReceivableSheetInterface>;

const useStyles = makeStyles({
  input: {
    width: 160,
  },
});

export const InvoiceNumberField: FC<InvoiceNumberFieldProps> = ({ record }) => {
  const classes = useStyles();
  const { hasPermission } = PermissionsProvider.useContainer();
  const canEdit = hasPermission(CAN_EDIT_RECEIVABLE);
  const { invoiceNumberInput, errors, submitting, setInvoiceNumberInput } =
    useInvoiceDraft(record, canEdit);

  if (!record) return null;

  if (!canEdit) {
    return <span>{record.internalInvoiceNumber ?? ''}</span>;
  }

  return (
    <Box className={classes.input}>
      <TextField
        value={invoiceNumberInput}
        onChange={event => setInvoiceNumberInput(event.target.value)}
        disabled={submitting}
        error={Boolean(errors.invoiceNumber)}
        helperText={errors.invoiceNumber ?? ''}
        placeholder="Invoice #"
      />
    </Box>
  );
};

export default InvoiceNumberField;
